// extracted by mini-css-extract-plugin
export var arrow = "select-module--arrow--eobAy";
export var wrapper = "select-module--wrapper--7Hbk8";